import { ViewConfig } from "@lib/views";
import { AMOUNT_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import {
    CatalogItemPriceColumn,
    CatalogItemPriceRow,
} from "./catalogItemPrices.types";
import { PriceRateCell } from "./Cells/PriceRateCell";
import { PriceDescriptionCell } from "./Cells/PriceDescriptionCell";
import { PriceCreatedOnCell } from "./Cells/PriceCreatedOnCell";
import { PriceStatusCell } from "./Cells/PriceStatusCell";
import { PriceActionsCell } from "./Cells/PriceActionsCell";

export const catalogItemPriceViewConfig: ViewConfig<
    CatalogItemPriceRow,
    CatalogItemPriceColumn,
    never
> = {
    columns: {
        [CatalogItemPriceColumn.PRICE]: {
            accessorKey: "unitAmount",
            name: "Price",
            header: "Price",
            cell: PriceRateCell,
            align: "right",
            ...AMOUNT_COLUMN_SIZE,
        },
        [CatalogItemPriceColumn.DESCRIPTION]: {
            accessorKey: "description",
            name: "Description",
            header: "Description",
            cell: PriceDescriptionCell,
            minSize: 200,
            maxSize: 400,
        },
        [CatalogItemPriceColumn.CREATED_ON]: {
            accessorKey: "createdAt",
            name: "Created on",
            header: "Created on",
            cell: PriceCreatedOnCell,
            minSize: 120,
            maxSize: 140,
        },
        [CatalogItemPriceColumn.STATUS]: {
            accessorKey: "isDefault",
            name: "Status",
            header: "Status",
            cell: PriceStatusCell,
            minSize: 100,
            maxSize: 140,
        },
        [CatalogItemPriceColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            immutable: true,
            hiddenFromSettings: true,
            cell: PriceActionsCell,
            minSize: 60,
            maxSize: 60,
        },
    },
};
